import styled from '@emotion/styled';

export type PopupPosition = '좌측상단' | '중앙' | '우측상단' | '좌측하단' | '우측하단';

export const PopupLayer = styled.div`
	position: fixed;
	inset: 0;
	z-index: 30;
	pointer-events: none;
`;

export const PopupMask = styled.div`
	position: fixed;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.45);
	pointer-events: auto;
`;

export const PopupList = styled.div<{ $count: number }>`
	position: relative;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

export const PopupCard = styled.section<{
	$position: PopupPosition;
	$offsetX: number;
	$offsetY: number;
	$dragX: number;
	$dragY: number;
	$zIndex: number;
}>`
	position: fixed;
	display: flex;
	flex-direction: column;
	width: 32vw;
	max-width: 64rem;
	min-width: 40rem;
	background-color: #fff;
	box-shadow: 0 1.2rem 3.2rem rgba(0, 0, 0, 0.2);
	border: 1px solid #dee2e6;
	pointer-events: auto;
	z-index: ${({ $zIndex }) => $zIndex};
	${({ $position, $offsetX, $offsetY, $dragX, $dragY }) => {
		if ($position === '중앙') {
			return `
				top: calc(50% + ${$offsetY}px);
				left: calc(50% + ${$offsetX}px);
				transform: translate(calc(-50% + ${$dragX}px), calc(-50% + ${$dragY}px));
			`;
		}

		if ($position === '우측상단') {
			return `
				top: calc(9.6rem + ${$offsetY}px);
				right: calc(2rem + ${$offsetX}px);
				transform: translate(${-$dragX}px, ${$dragY}px);
			`;
		}

		if ($position === '좌측하단') {
			return `
				bottom: calc(2rem + ${$offsetY}px);
				left: calc(2rem + ${$offsetX}px);
				transform: translate(${$dragX}px, ${-$dragY}px);
			`;
		}

		if ($position === '우측하단') {
			return `
				bottom: calc(2rem + ${$offsetY}px);
				right: calc(2rem + ${$offsetX}px);
				transform: translate(${-$dragX}px, ${-$dragY}px);
			`;
		}

		return `
			top: calc(9.6rem + ${$offsetY}px);
			left: calc(2rem + ${$offsetX}px);
			transform: translate(${$dragX}px, ${$dragY}px);
		`;
	}}

	@media screen and (max-width: 900px) {
		top: ${({ $offsetY }) => `calc(8rem + ${$offsetY * 0.8}px)`};
		left: 50%;
		right: auto;
		bottom: auto;
		transform: translate(calc(-50% + ${({ $offsetX, $dragX }) => `${$offsetX * 0.6 + $dragX}px`}), ${({ $dragY }) => `${$dragY}px`});
		width: min(36rem, calc(100vw - 2rem));
		max-width: none;
		min-width: 0;
	}
`;

export const PopupHeader = styled.div<{ $isDragging: boolean }>`
	display: flex;
	align-items: center;
	padding: 1.2rem 1.6rem;
	border-bottom: 1px solid #dee2e6;
	cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'grab')};
	user-select: none;
`;

export const PopupTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
`;

export const PopupImageButton = styled.button`
	display: flex;
	width: 100%;
	padding: 0;
	background: transparent;
	border: none;
	cursor: pointer;
	&:disabled {
		cursor: default;
	}
`;

export const PopupImage = styled.img`
	display: block;
	width: 100%;
	height: auto;
	object-fit: cover;
`;

export const PopupFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.2rem 1.6rem;
	gap: 1.2rem;
	border-top: 1px solid #dee2e6;
	background-color: #f8f9fa;
`;

export const PopupActionButton = styled.button`
	display: inline-flex;
	align-items: center;
	padding: 0;
	background: transparent;
	border: none;
	color: #495057;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	cursor: pointer;
`;

export const PopupCloseButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 7.2rem;
	height: 3.6rem;
	padding: 0 1.2rem;
	background-color: ${(props) => props.theme.colors.primary400};
	border: none;
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	cursor: pointer;
`;
